import React, { Component } from 'react';
import { browserHistory, Link, hashHistory } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import YouTube from 'react-youtube';
import { PanelGroup, Panel } from 'react-bootstrap';
import utils from '../../utils/config.js';
class Version_History extends Component {
  _onReady(event) {
// access to player in all event handlers via event.target
event.target.pauseVideo();
}
    render() {
      const opts = {
      height: '240',
      width: '426',
      playerVars: { // https://developers.google.com/youtube/player_parameters
        autoplay: 1
      }
      //<Panel header="Penn State TV Ad" eventKey="5"><YouTube videoId="rTOXOoWLqD8" opts={opts} onReady={this._onReady} /></Panel>

    }
        return (
            <div>
                <form className="bodyText">
                  <span className="headerText">Version History</span>
                  <br/><br/>
                  <PanelGroup defaultActiveKey="6" accordion>
                  <Panel header="v1.0 - 8/30/2017 | Trick Strat™ launch + Gears of War 4." eventKey="1"><YouTube videoId="OvSPgelsMEc" opts={opts} onReady={this._onReady} /></Panel>
                  <Panel header="v1.01 - 9/13/2017 | Stamps + LawBreakers." eventKey="2"><YouTube videoId="2NdGYhLGvH4" opts={opts} onReady={this._onReady} /></Panel>
                  <Panel header="v1.02 - 11/22/2017 | Esports Playbook + Sports." eventKey="3"><YouTube videoId="-llWeTbkGnE" opts={opts} onReady={this._onReady} /></Panel>
                  <Panel header="v1.03 - 9/14/2019 | GEARS 5" eventKey="4">Gears 5 maps added.</Panel>
                  <Panel header="v1.04 - 4/11/2020 | VALORANT" eventKey="5">Valorant maps added.</Panel>
                  <Panel header="v1.05 - 8/23/2020 | ROGUECOMPANY" eventKey="6">Rogue Company maps added.</Panel>

                  </PanelGroup>
                </form>
            </div>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
    }, dispatch);
}

function mapStateToProps(state) {
    return { currentUser: state.currentUser };
}

export default connect(mapStateToProps, mapDispatchToProps)(Version_History);



// WEBPACK FOOTER //
// ./src/app/components/version_history/index.jsx